<section class="section section--creditBureau">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <form [formGroup]="consentForm" class="form full__height">
          <div class="content__main">
            <article class="mainInfo pb-30">
              <h1 class="pb-10">Solicitud de reporte de crédito</h1>
              <p>Autorizá la solicitud del reporte de crédito dando tu consentimiento.</p>
            </article>

            <article class="creditBureau pb-20">
              <p-accordion class="w-full" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
                <p-accordionTab iconPos="end">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <div class="info">
                        <div class="icon">
                          <i>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="27" viewBox="0 0 23 27" fill="none">
                              <path d="M5.96522 15.6977C5.73877 15.6974 5.52169 15.6072 5.36161 15.447C5.20152 15.2868 5.1115 15.0696 5.11129 14.8431C5.11155 14.6166 5.20158 14.3994 5.36165 14.2392C5.52171 14.079 5.73876 13.9888 5.96518 13.9885H17.0346C17.2611 13.9887 17.4783 14.0788 17.6385 14.239C17.7986 14.3992 17.8887 14.6165 17.8889 14.8431C17.8887 15.0697 17.7986 15.2869 17.6385 15.4471C17.4783 15.6074 17.2611 15.6975 17.0346 15.6977H5.96522ZM5.96522 11.6389C5.73877 11.6386 5.52167 11.5485 5.36155 11.3883C5.20143 11.2281 5.11136 11.011 5.11111 10.7844C5.11136 10.5579 5.20143 10.3407 5.36155 10.1805C5.52167 10.0204 5.73877 9.93026 5.96522 9.93001H14.2562C14.4826 9.93032 14.6996 10.0204 14.8597 10.1806C15.0198 10.3407 15.1098 10.5578 15.1101 10.7843C15.1099 11.0107 15.0198 11.2279 14.8598 11.3881C14.6997 11.5482 14.4826 11.6384 14.2562 11.6387L5.96522 11.6389ZM5.96522 7.35961C5.73883 7.35931 5.52181 7.26921 5.36173 7.10908C5.20166 6.94894 5.1116 6.73184 5.11129 6.50537C5.11161 6.27892 5.20167 6.06183 5.36173 5.9017C5.5218 5.74157 5.73881 5.65147 5.96518 5.65116H17.0346C17.261 5.65141 17.478 5.74148 17.6381 5.90162C17.7982 6.06176 17.8883 6.27889 17.8885 6.50537C17.8883 6.73184 17.7982 6.94897 17.6381 7.10911C17.4781 7.26925 17.261 7.35932 17.0346 7.35958L5.96522 7.35961Z" fill="#7395C8"/>
                              <path d="M2.90198 27C1.30175 27 0 25.729 0 24.1667V2.83313C0 1.27085 1.30175 0 2.90198 0H20.098C21.698 0 23 1.27106 23 2.83331V19.8762C22.9995 20.0854 22.9272 20.2883 22.7947 20.4526L17.7909 26.6451C17.702 26.756 17.5883 26.8456 17.4586 26.9071C17.3289 26.9686 17.1865 27.0003 17.0422 27H2.90198ZM2.9018 1.86262C2.63847 1.8633 2.38612 1.96573 2.19991 2.14751C2.01371 2.3293 1.90879 2.57565 1.90809 2.83274V24.1667C1.9087 24.4238 2.01359 24.6703 2.19981 24.8521C2.38603 25.0339 2.63843 25.1364 2.9018 25.137H15.4673V21.3355C15.4673 19.7734 16.7691 18.5024 18.3693 18.5024H21.0919V2.83313C21.0912 2.576 20.9863 2.32959 20.8 2.14777C20.6138 1.96594 20.3614 1.86349 20.098 1.8628L2.9018 1.86262ZM18.3691 20.3654C18.1059 20.366 17.8536 20.4684 17.6674 20.6501C17.4812 20.8318 17.3763 21.0781 17.3756 21.3351V24.1519L20.4351 20.3654H18.3691Z" fill="#7395C8"/>
                            </svg>
                          </i>
                        </div>
                        <div class="text">
                          <h2>Autorización</h2>
                          <p class="textShowDoc">Ver documento</p>
                          <p class="textHideDoc">Ocultar documento</p>
                        </div>
                      </div>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="accordion-content">
                      <div class="authorization__textHtml" [innerHTML]="authorizationHTML | safeHtml"></div>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </article>

            <article class="creditBureau__checkbox">
              <div class="form__checkbox">
                <div class="form__checkboxItem">
                  <p-checkbox formControlName="acceptTerms" [binary]="true" inputId="creditBureau"></p-checkbox>
                  <label class="small" for="creditBureau">Acepto los términos de la autorización para la solicitud de mi reporte de crédito.</label>
                </div>
              </div>
            </article>
          </div>

          <div class="content__footer">
            <button pButton pRipple label="Confirmar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [disabled]="consentForm.invalid || isSubmitting" [loading]="isSubmitting" (click)="onConfirm()"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
